import React, {Component, Fragment} from "react";
import ExportableComponent from "../export/ExportableComponent";
import {Col, Container, Image, Row} from "react-bootstrap";
import classNames from 'classnames';

import '../../../assets/sass/global/report/report-file.scss';

import dustinWilliamsonAvatar from "../../../assets/img/demo/dustin-williamson-avatar@2x.png";
import annFloresAvatar from "../../../assets/img/demo/ann-flores-avatar@2x.png";
import VideosPerMatchModal from "../../pages/dashboard/full_profile/modals/VideosPerMatchModal";
import {bolt, brain, bullsEyeArrow, handRock, running, shield, star} from "../Icon";
import InfoCard from "../tabs/scouting_reports_tab_base/InfoCard";
import PlayerAbilityCard from "../cards/PlayerAbilityCard";
import PlayerAbilityTable from "../sections/PlayerAbilityTable";


const items = [
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [{name: 'Adel', type: 'pdf'}]},
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: []},
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: []},
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: []},
    {title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: []},
];

const playerAbilities = [
    {title: 'Attacking', icon: bullsEyeArrow, items: items},
    {title: 'Skills', icon: handRock, items: items},
    {title: 'Movement', icon: running, items: items},
    {title: 'Power', icon: bolt, items: items},
    {title: 'bolt', icon: brain, items: items},
    {title: 'Defence', icon: shield, items: items},
    {title: 'Goal Keeping', icon: bolt, items: items},
    {title: 'Specialities', icon: star, items: items},
];

const PlayerInformation = (props) => {
    const {avatar, name, team, positions} = props;
    const positionsTeamFormat = (positions, team) => `${positions} | ${team}`;

    return (
        <div className="player-information">
            <Image className="avatar" src={avatar} roundedCircle/>
            <div className="text-container">
                <div className="name"> {name}</div>
                <div className="positions-team"> {positionsTeamFormat(positions, team)}</div>
            </div>
        </div>
    );
};

const PlayerBasicInformation = (props) => {
    const {title, value} = props;

    return (
        <div className="player-basic-information">
            <div className="title"> {title} </div>
            <div className="value"> {value} </div>
        </div>
    );
};

class ReportFile extends ExportableComponent {
    render = () => this.renderContent();

    renderContent = () => {
        const { styleType } = this.props;

        return (
            <div className={classNames("report-file", styleType || 'default')}>
                {this.renderHeader()}
                {styleType === 'compact' ? this.renderCompactBody() : this.renderBody()}
            </div>
        );
    };

    renderHeader = () => {
        return (
            <div className="report-file--header">
                {this.renderTitle()}
                {this.renderReportingElements()}
                <div className="horizontal-divider"/>
                {this.renderPlayerBasicInformation()}
            </div>
        );
    };

    renderTitle = () => {
        const title = "Scouting Report";
        return (
            <div className="title"> {title} </div>
        );
    };

    renderReportingElements = () => {
        const title1 = "For Player";
        const title2 = "Report By";
        const player1 = {
            name: 'Dustin Williamson',
            positions: 'CF, RAMF, RWF',
            team: 'Real Madrid',
            avatar: dustinWilliamsonAvatar,
        };
        const player2 = {
            name: 'Dustin Williamson',
            positions: 'CF, RAMF, RWF',
            team: 'Real Madrid',
            avatar: dustinWilliamsonAvatar,
        };

        return (
            <div className="reporting-elements">
                <div className="for-player">
                    <div className="title"> {title1} </div>
                    <PlayerInformation {...player1}/>
                </div>
                <div className="vertical-divider"/>
                <div className="report-by rtl">
                    <div className="title"> {title2} </div>
                    <PlayerInformation {...player2}/>
                </div>
            </div>
        );
    };

    renderPlayerBasicInformation = () => {
        const items = [
            {title: 'Age', value: '24Yrs'},
            {title: 'Foot', value: 'Left'},
            {title: 'Nationality', value: 'Brazil'},
            {title: 'Passport', value: 'Brazil'},
            {title: 'Total Matches', value: '89'},
            {title: 'Total Goals', value: '45'},
        ];

        return (
            <div className="items">
                {items.map((item, index) => <ReportFile.PlayerBasicInformation key={index} title={item.title} value={item.value}/>)}
            </div>
        );
    };

    renderBody = () => {
        return (
            <Container fluid={true} className="report-file--body">
                <Row className="overview report-row">
                    <Col xs="3">
                        <ReportFile.InfoCard title="Over All Score" description="83"/>
                    </Col>
                    <Col xs="9">
                        <ReportFile.InfoCard title="Over All Evaluation Comment" description="Dustin is the calm player and has a good control over the ball and mind, Good Passing and Shooting skills"/>
                    </Col>
                </Row>
                <Row className="report-row">
                    {playerAbilities.map((playerAbility, index) =>
                        <Fragment key={index}>
                            <Col xs="12" key={index}>
                                <ReportFile.PlayerAbility withHorizontalDivider={true} title={playerAbility.title} icon={playerAbility.icon} items={playerAbility.items} onAttachmentClick={() => this.setModalShow(VideosPerMatchModal.Name, true)} />
                            </Col>
                        </Fragment>
                    )}
                </Row>
            </Container>
        );
    };

    renderCompactBody = () => {
        return (
            <Container fluid={true} className="report-file--body">
                <Row className="overview report-row">
                    <Col xs="3">
                        <ReportFile.InfoCard title="Over All Score" description="50"/>
                    </Col>
                    <Col xs="9">
                        <ReportFile.InfoCard title="Over All Evaluation Comment" description="Dustin is the calm player and has a good control over the ball and mind, Good Passing and Shooting skills"/>
                    </Col>
                </Row>
                <Row className="report-row">
                    {playerAbilities.map((playerAbility, index) =>
                        <Fragment>
                            <Col xs="12" key={index}>
                                <ReportFile.PlayerAbilityTable
                                    title={playerAbility.title}
                                    icon={playerAbility.icon}
                                    items={playerAbility.items}
                                />
                            </Col>
                        </Fragment>
                    )}
                </Row>
            </Container>
        );
    };

    static defaultProps = {
        styleType: 'default'
    }
}

ReportFile.PlayerAbility = PlayerAbilityCard;
ReportFile.PlayerAbilityTable = PlayerAbilityTable;
ReportFile.InfoCard = InfoCard;
ReportFile.PlayerBasicInformation = PlayerBasicInformation;

export default ReportFile;
